/**
 * gen.ai's decorative gradients, held locally.
 *
 * `@picsart/design-system` v11 shipped these as flat foundation tokens
 * (`Gradients.valentine` / `.aura` / `.lotus`). v13 restructured `Gradients`
 * into groups — `general`, `status`, `monetization`, `background` — and dropped
 * the seasonal palette these came from entirely.
 *
 * The values below are the v11 definitions verbatim, so the DS 13 upgrade does
 * not silently restyle the hero, the tab chips or the draggable cards. The
 * nearest surviving token (`Gradients.general.brand`) is a different ramp; using
 * it here would have changed the product's look as a side effect of a dependency
 * bump rather than as a design decision.
 *
 * `pro` needs the same treatment even though v13 still has a `pro`, because the
 * name survived the restructure but the value did not:
 *
 *   v11  --gradients-pro:              linear-gradient(60.72deg, #0e00ac -11%, #ff34f9 100%)
 *   v13  --gradients-monetization-pro: linear-gradient(270deg, #8a43ff 0%, #5600e3 100%)
 *
 * v11's was a decorative indigo-into-magenta ramp; v13's is the Pro *tier*
 * colour, a flat violet, sitting alongside plus/ultra as a set of plan badges.
 * The active tab chip is decoration, not a monetization surface, so it wants the
 * former — pointing it at `Gradients.monetization.pro` turned the chip violet.
 *
 * Anything whose DS equivalent kept its meaning should keep using the token.
 */
export const BrandGradients = {
  valentine: 'linear-gradient(315deg, #f44097 25%, #fc67fa 75%)',
  aura: 'linear-gradient(315deg, #fbeac9 14.64%, #abb8fd 84.73%)',
  lotus: 'linear-gradient(315deg, #b5b5ff 14.64%, #fbc7d4 85.36%)',
  pro: 'linear-gradient(60.72deg, #0e00ac -11%, #ff34f9 100%)',
} as const;
